import { makeStyles } from "@material-ui/core";

import prisaIcon from "./prisa-icon.png";

const useStyles = makeStyles({
  root: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    height: 30,
    paddingLeft: 4,
  },
  icon: {
    width: 28,
    height: 28,
  },
  svg: {
    width: "auto",
    height: 24,
  },
});

const LogoFull = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <img src={prisaIcon} alt="" className={classes.icon} />
      <svg
        className={classes.svg}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 280 40"
      >
        <text
          x="0"
          y="30"
          fontFamily="'Helvetica Neue', Helvetica, Arial, sans-serif"
          fontSize="28"
          fontWeight="700"
          fill="#7df3e1"
          letterSpacing="0.5"
        >
          <tspan>PRISA</tspan>
          <tspan fontWeight="400"> Media</tspan>
        </text>
      </svg>
    </div>
  );
};

export default LogoFull;
